import HoleEffect from "@/components/main/hole-effect";

export default function ArtTherapy() {
  const iconCheck: any = (
    <i className="bi bi-bookmark-check-fill beart-icon1"></i>
  );
  const iconPlus: any = (
    <i className="bi bi-bookmark-plus-fill beart-icon1"></i>
  );
  const iconPalette: any = <i className="bi bi-palette beart-icon1"></i>;
  const iconBrush: any = <i className="bi bi-brush beart-icon1"></i>;
  const iconPencil: any = <i className="bi bi-pencil beart-icon1"></i>;
  const iconDrop: any = <i className="bi bi-droplet beart-icon1"></i>;
  const iconPeople: any = <i className="bi bi-people-fill beart-icon1"></i>;
  const iconYin: any = <i className="bi bi-yin-yang beart-icon1"></i>;

  return (
    <>
      <section className="beart-section">
        <div className="beart-title">A művészetterápia pozitív hatása</div>
        <ul className="zoom-fader mb-4 list-outside">
          <li className="mb-2 flex">
            {iconPlus}
            <div>
              Szorongás vizsgálatok kutatások kimutatták, hogy már 5 percnyi
              agyaggal végzett gyakorlat is stresszcsökkentő hatású és az
              érzelmek kifejezését segíti.
            </div>
          </li>
          <li className="mb-2 flex">
            {iconPlus}
            <div>
              További többezer résztvevővel végzett kutatás eredménye szerint 20
              percnyi mandala színezés szorongáscsökkentő hatású, csökken a
              pulzusszám az alkotások során, lassul a légzés, csökken a
              vérnyomás is.
            </div>
          </li>
          <li className="mb-2 flex">
            {iconPlus}
            <div>
              Depresszióval küzdő fiatalok és felnőttek csoportjait vizsgálva a
              kutatást végzők a következő eredményre jutottak, a csoportos
              művészetterápia hozzájárult a résztvevők jó közérzetének
              kialakulásához, az önmegértést, a szociális és megküzdési
              készségeiket növelte, javította a mentális egészségét, az alvás
              minőségét és a pszichológiai jólétüket is.
            </div>
          </li>
          <li className="mb-2 flex">
            {iconPlus}
            <div>
              A művészetterápia kreatív alkotása folyamatában a résztvevők
              szabályozhatták az érzelmeiket, csökkent a szorongásuk, ami az
              érzelmi jólétükben segített. Aktivizálódtak a jutalmazási utak az
              agyban (dopamin szabadult fel) ami elősegítette a pozitív
              érzelmeket, a csökkent kortizol szint stresszcsökkentő hatású
              volt.
            </div>
          </li>
        </ul>

        <div className="beart-title">Eszközök és hatásuk</div>
        <ul className="zoom-fader mb-4 list-outside">
          <li className="mb-2 flex">
            {iconPencil}
            <div>
              A ceruzarajzok a koncentrációt segítik, a frontális lebenyre
              hatnak.
            </div>
          </li>
          <li className="mb-2 flex">
            {iconPalette}
            <div>
              A vízfestékkel festés aktiválja az érzelmi szabályozásban részt
              vevő agyi régiókat, mint például a prefrontális kéreg és az
              amygdala.
            </div>
          </li>
          <li className="mb-2 flex">
            {iconYin}
            <div>
              Agyaggal végzett feladatok során az érintés és a tapintható
              érzékelés magában foglalja a mozgást és az érzelmeket is
              aktiválja, az amygdala információt kap a szomatoszenzoros primer
              kéregből.
            </div>
          </li>
          <li className="mb-2 flex">
            {iconPeople}
            <div>
              Művészetterápia, különösen csoportban, aktiválhatja a
              tükörneuronokat, ami elősegíti az empátiát, a szociális kötődést
              és a kapcsolódás érzését. A művészetterápia segíti a
              neuroplaszticitást, serkenti az új neuronok növekedését,
              erősítheti a meglévő idegpályákat, így lehetővé teszi az új
              megküzdési stratégiák kidolgozását. Összeségében elmondható, hogy
              a kreatív tevékenységben, az alkotás izgalma, egy új dolog
              tanulása és a részvétel öröme is megélhető, ez mind
              stresszcsökkentő hatású és a kiégés megelőzésének eszköze is
              egyben.
            </div>
          </li>
        </ul>
      </section>
      <HoleEffect>
        <section className="mx-auto w-3/4 bg-black bg-opacity-40 p-8 text-white">
          <div className="mb-4 text-3xl font-bold text-white shadow-black drop-shadow-2xl">
            Mi történik egy művészetterápiás foglalkozáson?
          </div>
          <div className="text-xl font-medium text-white shadow-black drop-shadow-2xl">
            <p>
              A művészetterápiás gyakorlatok segítségével, ami lehet festés,
              rajzolás, kollázs készítés, írás, agyagozás, gyurmázás, mozgás, a
              résztvevők kreatívan kifejezhetik magukat, kapcsolatba kerülhetnek
              érzelmeikkel, és új nézőpontokat kaphatnak a helyzeteikre,
              problémáikra.
            </p>
            <p className="mt-4">
              A kiscsoportos foglalkozás időt és teret ad az egyéni folyamatok
              elmélyítésére.
            </p>
            <p className="mt-4">
              A művészetterápiás gyakorlatokban megélhetik a résztvevők az
              alkotás örömét, új és változatos gyakorlatokat végezhetnek,
              elkészült alkotások sikerélményt adnak, az önkifejezés lehetőségét
              és egyfajta flow élményt, áramlás élményt is megtapasztalhatnak.
              Elmondhatják az elkészült alkotásról a gondolataikat, érzéseiket,
              visszajelzéseket kaphatnak, ami fejleszti a kommunikációt, nő az
              önreflexiós készlettára, az önbizalma és a belső autonómia élménye
              is erősödik ezáltal, új megoldási lehetőségeket fedezhet fel.
            </p>
          </div>
        </section>
      </HoleEffect>
    </>
  );
}
